import React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import Button from '@/Components/Button';

interface Props {
  trigger: React.ReactNode;
  title: string;
  description: string;
  actionText: string;
  actionHandler: () => void;
  cancelText?: string;
  cancelHandler?: () => void;
}

export default function Dialog({
  trigger,
  title,
  description,
  actionText,
  actionHandler,
  cancelText,
  cancelHandler,
}: Props) {
  return (
    <DialogPrimitive.Root>
      <DialogPrimitive.Trigger>
        {trigger}
      </DialogPrimitive.Trigger>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 dark:bg-brand-dark-100 opacity-60" />
        <DialogPrimitive.Content
          className="dark:bg-brand-dark-25 top-1/2 left-1/2 translate-y-[-50%] translate-x-[-50%] fixed w-96 rounded-xl"
        >

          <DialogPrimitive.Title className="dark:text-brand-25 font-bold p-3 text-center">
            {title}
          </DialogPrimitive.Title>

          <DialogPrimitive.Description className="dark:text-brand-25 px-3 pb-3 text-center">
            {description}
          </DialogPrimitive.Description>

          <div className="flex justify-between p-3">
            <DialogPrimitive.Close asChild>
              <Button onClick={cancelHandler} className="dark:text-brand-25">
                {cancelText ?? 'Close'}
              </Button>
            </DialogPrimitive.Close>

            <DialogPrimitive.Close asChild>
              <Button onClick={actionHandler} className="dark:text-brand-25">
                {actionText}
              </Button>
            </DialogPrimitive.Close>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
